export const customMapSlider = (currentIndex, minIndex, maxIndex) => {
  const rangeInput = ref(null)
  let isTouching = false

  const handleTouchStart = (e) => {
    isTouching = true
    updateSliderFromTouch(e.touches[0])
  }

  const handleTouchMove = (e) => {
    if (!isTouching) return
    e.preventDefault()
    updateSliderFromTouch(e.touches[0])
  }

  const handleTouchEnd = () => {
    isTouching = false
  }

  const updateSliderFromTouch = (touch) => {
    if (!rangeInput.value) return

    const rect = rangeInput.value.getBoundingClientRect()
    const percentage = Math.max(0, Math.min(1, (touch.clientX - rect.left) / rect.width))
    const newValue = Math.round(minIndex.value + (maxIndex.value - minIndex.value) * percentage)

    if (newValue !== currentIndex.value) {
      currentIndex.value = newValue
    }
  }

  const initTouchEvents = () => {
    if (rangeInput.value) {
      rangeInput.value.addEventListener('touchstart', handleTouchStart, { passive: false })
      rangeInput.value.addEventListener('touchmove', handleTouchMove, { passive: false })
      rangeInput.value.addEventListener('touchend', handleTouchEnd)
    }
  }

  const removeTouchEvents = () => {
    if (rangeInput.value) {
      rangeInput.value.removeEventListener('touchstart', handleTouchStart)
      rangeInput.value.removeEventListener('touchmove', handleTouchMove)
      rangeInput.value.removeEventListener('touchend', handleTouchEnd)
    }
  }

  return {
    rangeInput,
    initTouchEvents,
    removeTouchEvents
  }
}
